import PushNotificationsServices from "@/services/PushNotificationsServices";

const state = {
  loadingNotifications: false,
  notifications: [],
  pushNotificationPaging: [],
  paginationPushNotification: {
    descending: true,
    page: 1,
    rowsPerPage: 20,
    sortBy: 'modificationDate',
    totalItems: 0,
    rowsPerPageItems: [10, 20, 50, 100]
  },
};

const getters = {
  notifications: state => {
    return state.notifications;
  },
  loadingNotifications: state => {
    return state.loadingNotifications;
  },
  pushNotificationPaging: state => {
    return state.pushNotificationPaging;
  },
  paginationPushNotification(state) {
    return state.paginationPushNotification
  },
};

const actions = {
  getNotifications(context, payload) {
    context.commit("showLoadingNotificationsIndicator");
    const {
      sortBy,
      descending,
      page,
      rowsPerPage
    } = context.state.paginationPushNotification

    return PushNotificationsServices.getNotifications(page, rowsPerPage, sortBy, descending, payload)
      .then(res => {
        if (res.data.error == 0) {
          const items = res.data.data.content;
          const totalItems = res.data.data.total;
          context.commit('_setPushNotificationPaging', {
            items,
            totalItems
          })
        } else {
          const items = [];
          const totalItems = 0;
          context.commit('_setPushNotificationPaging', {
            items,
            totalItems
          })
        }
      })
      .finally(res => {
        context.commit("hideLoadingNotificationsIndicator");
      });
  },
  createNotification(context, payload) {
    context.commit("showLoadingNotificationsIndicator");
    return PushNotificationsServices.createNotification(payload).finally(res => {
      context.commit("hideLoadingNotificationsIndicator");
    });
  }
};

const mutations = {
  showLoadingNotificationsIndicator(state) {
    state.loadingNotifications = true;
  },
  hideLoadingNotificationsIndicator(state) {
    state.loadingNotifications = false;
  },
  setPaginationPushNotification(state, payload) {
    state.paginationPushNotification = payload
  },
  _setPushNotificationPaging(state, {
    items,
    totalItems
  }) {
    state.pushNotificationPaging = items
    state.paginationPushNotification.totalItems = totalItems
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};